import React, { useEffect, useState } from "react";
import UserServices from "../services/externalServices/userServices";
import { Link } from "react-router-dom";
import Rating from '@mui/material/Rating';
import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';

function TopUsers() {
  const [topUsers, setTopUser] = useState([]);
  useEffect(() => {
    getTopUsers();
  }, []);
  const getTopUsers = async () => {
    try {
      const response = await UserServices.getUserTripCount();
      const topUser = response.sort((a, b) => b.count - a.count);
      setTopUser(topUser);
    } catch (err) {
      console.error("error while getting the Top User", err);
    }
  };
  return (
    <div className="col-lg-8 col-md-12 col-sm-12 col-12 "style={{marginLeft:'8px'}}>
    <div className="card-box">
        <div className="card-head">
            <header>Top Users</header>
        </div>
        {/* <div className="card-body"> */}
          <Paper>
            <div className="row ml-4">
                <div className="slimScrollDiv" style={{ position: 'relative', width: 'auto'  }}>
                    <ul className="docListWindow small-slimscroll-style" style={{ listStyleType: 'none', padding: 0 }}>
                        {topUsers.map((user, index) => (
                            <li key={index}>
                                <div className="row align-items-center">
                                    <div className="col-md-8 col-sm-8 d-flex align-items-center">
                                        <div className="prog-avatar mr-3"   style={{ marginRight: '16px',marginLeft:'5px' }}>
                                            <Avatar>{user.userDetails.first_name.slice(0, 1)}</Avatar>
                                        </div>
                                        <div className="details" style={{ marginTop: '16px' }}>
                                            <div className="title">
                                                <Link to={`/users/${user.user}`} style={{ textDecoration: 'none' }}>
                                                    <strong className="mb-0">{user.userDetails.first_name}</strong>
                                                </Link>
                                                <p className="rating-text">Trips: {user.count}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 rating-style">
                                        <Rating name="read-only" value={user.userDetails.rating} readOnly />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="full-width text-center p-t-10">
                    <a href="#" className="btn purple btn-outline btn-circle margin-0">View All</a>
                </div>
            </div>
            </Paper>
        {/* </div> */}
    </div>
</div>
    // <div className="container">
      
    //     <div className="card">
    //       <h5 className="card-title">Top Users</h5>

    //       <div
    //         className="card-body"
    //         style={{ backgroundColor: "rgba(113, 179, 238, 0.12)" }}
    //       >
    //         {topUsers.map((user, index) => (
    //           <div key={index} className="d-flex justify-content-between mb-3">
    //             <div>
    //               <Link to={`/users/${user.user}`}>
    //                 {" "}
    //                 {/* Example for to prop */}
    //                 <strong className="mb-0">
    //                   {user.userDetails.first_name}
    //                 </strong>
    //               </Link>
    //             </div>
    //             <small className="text-muted">Trips: {user.count}</small>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
      
    // </div>
    // <div className="col-lg-8 col-md-12 col-sm-12 col-12">
		// 					<div className="card-box ">
		// 						<div className="card-head">
		// 							<header>Guest Review</header>
		// 							<div className="tools">
		// 								<a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
		// 								<a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
		// 								<a className="t-close btn-color fa fa-times" href="javascript:;"></a>
		// 							</div>
		// 						</div>
		// 						<div className="card-body ">
		// 							<div className="row">
		// 								<div className="slimScrollDiv" style="position: relative; overflow: hidden; width: auto;"><ul className="docListWindow small-slimscroll-style" style="overflow: hidden; width: auto;">
		// 									<li>
		// 										<div className="row">
		// 											<div className="col-md-8 col-sm-8">
		// 												<div className="prog-avatar">
		// 													<img src="../../assets/img/user/user1.jpg" alt="" width="40" height="40"/>
		// 												</div>
		// 												<div className="details">
		// 													<div className="title">
		// 														<a href="#">Rajesh Mishra</a>
		// 														<p className="rating-text">Awesome!!! Highly recommend</p>
		// 													</div>
		// 												</div>
		// 											</div>
		// 											<div className="col-md-4 col-sm-4 rating-style">
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star_half</i>
		// 												<i className="material-icons">star_border</i>
		// 											</div>
		// 										</div>
		// 									</li>
		// 									<li>
		// 										<div className="row">
		// 											<div className="col-md-8 col-sm-8">
		// 												<div className="prog-avatar">
		// 													<img src="../../assets/img/user/user2.jpg" alt="" width="40" height="40"/>
		// 												</div>
		// 												<div className="details">
		// 													<div className="title">
		// 														<a href="#">Sarah Smith</a>
		// 														<p className="rating-text">Very bad service :(</p>
		// 													</div>
		// 												</div>
		// 											</div>
		// 											<div className="col-md-4 col-sm-4 rating-style">
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star_half</i>
		// 												<i className="material-icons">star_border</i>
		// 												<i className="material-icons">star_border</i>
		// 												<i className="material-icons">star_border</i>
		// 											</div>
		// 										</div>
		// 									</li>
		// 									<li>
		// 										<div className="row">
		// 											<div className="col-md-8 col-sm-8">
		// 												<div className="prog-avatar">
		// 													<img src="../../assets/img/user/user3.jpg" alt="" width="40" height="40"/>
		// 												</div>
		// 												<div className="details">
		// 													<div className="title">
		// 														<a href="#">John Simensh</a>
		// 														<p className="rating-text"> Staff was good nd i'll come
		// 															again</p>
		// 													</div>
		// 												</div>
		// 											</div>
		// 											<div className="col-md-4 col-sm-4 rating-style">
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 											</div>
		// 										</div>
		// 									</li>
		// 									<li>
		// 										<div className="row">
		// 											<div className="col-md-8 col-sm-8">
		// 												<div className="prog-avatar">
		// 													<img src="../../assets/img/user/user4.jpg" alt="" width="40" height="40"/>
		// 												</div>
		// 												<div className="details">
		// 													<div className="title">
		// 														<a href="#">Priya Sarma</a>
		// 														<p className="rating-text">The price I received was good
		// 															value.</p>
		// 													</div>
		// 												</div>
		// 											</div>
		// 											<div className="col-md-4 col-sm-4 rating-style">
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star_half</i>
		// 											</div>
		// 										</div>
		// 									</li>
		// 									<li>
		// 										<div className="row">
		// 											<div className="col-md-8 col-sm-8">
		// 												<div className="prog-avatar">
		// 													<img src="../../assets/img/user/user5.jpg" alt="" width="40" height="40"/>
		// 												</div>
		// 												<div className="details">
		// 													<div className="title">
		// 														<a href="#">Serlin Ponting</a>
		// 														<p className="rating-text">Not Satisfy !!!1</p>
		// 													</div>
		// 												</div>
		// 											</div>
		// 											<div className="col-md-4 col-sm-4 rating-style">
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star_border</i>
		// 												<i className="material-icons">star_border</i>
		// 												<i className="material-icons">star_border</i>
		// 												<i className="material-icons">star_border</i>
		// 											</div>
		// 										</div>
		// 									</li>
		// 									<li>
		// 										<div className="row">
		// 											<div className="col-md-8 col-sm-8">
		// 												<div className="prog-avatar">
		// 													<img src="../../assets/img/user/user6.jpg" alt="" width="40" height="40"/>
		// 												</div>
		// 												<div className="details">
		// 													<div className="title">
		// 														<a href="#">Priyank Jain</a>
		// 														<p className="rating-text">Good....</p>
		// 													</div>
		// 												</div>
		// 											</div>
		// 											<div className="col-md-4 col-sm-4 rating-style">
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star</i>
		// 												<i className="material-icons">star_half</i>
		// 												<i className="material-icons">star_border</i>
		// 											</div>
		// 										</div>
		// 									</li>
		// 								</ul><div className="slimScrollBar" style="background: rgb(158, 165, 171); width: 5px; position: absolute; top: 10px; opacity: 0.4; display: none; border-radius: 7px; z-index: 99; right: 1px; height: 199.876px;"></div><div className="slimScrollRail" style="width: 5px; height: 100%; position: absolute; top: 0px; display: none; border-radius: 7px; background: rgb(51, 51, 51); opacity: 0.2; z-index: 90; right: 1px;"></div></div>
		// 								<div className="full-width text-center p-t-10">
		// 									<a href="#" className="btn purple btn-outline btn-circle margin-0">View All</a>
		// 								</div>
		// 							</div>
		// 						</div>
		// 					</div>
		// 				</div>
  );
}

export default TopUsers;
